import { createSlice, current } from "@reduxjs/toolkit";

export interface INotificationState {
    isLoading: boolean;
    error: string;
    success: string;
    userNotificationsData: any;
    isUpdated: boolean;
}

const initialState: INotificationState = {
    isLoading: false,
    error: "",
    success: "",
    userNotificationsData: {},
    isUpdated: false,
};

export const notificationsRedux: any = createSlice({
    name: "notificationsRedux",
    initialState,
    reducers: {

        getAllUserNotificationsRequest: (state: any, action: any) => {
            const newState = {
                ...state,
                isLoading: true,
            };
            return newState;
        },
        getAllUserNotificationsSuccess: (state: any, action: any) => {
            const previousProfilesData: any = current(state?.userNotificationsData);
            const response = action?.payload?.data;
            const responseData: any =
                response?.currentPage === 1 ? [] : previousProfilesData?.responseData;
            console.log(action?.payload?.data, "success", previousProfilesData, responseData)

            const newState = {
                ...state,
                userNotificationsData: {
                    currentPage: response?.currentPage,
                    totalPages: response?.totalPages,
                    responseData: [...responseData, ...response?.responseData],
                },
                isLoading: false,
            };
            return newState;
        },
        getAllUserNotificationsFailure: (state: any, action: any) => {
            console.log(action?.payload?.data, "failed")
            const newState = {
                ...state,
                isLoading: false,
                userNotificationsData: [],
            };
            return newState;
        },

        updateNotificationRequest: (state: any, action: any) => {
            const newState = {
                ...state,
                isUpdated: false,
                userNotificationsData: {},
            };
            return newState;
        },
        updateNotificationSuccess: (state: any, action: any) => {
            const newState = {
                ...state,
                isUpdated: true,
            };
            return newState;
        },
        updateNotificationFailure: (state: any, action: any) => {
            console.log(action?.payload?.data, "failed")
            const newState = {
                ...state,
                isUpdated: false,
                userNotificationsData: [],
            };
            return newState;
        },
    },
});

export const {
    getAllUserNotificationsRequest,
    getAllUserNotificationsSuccess,
    getAllUserNotificationsFailure
} = notificationsRedux.actions;

export default notificationsRedux.reducer;
